"use client";

import { useEffect, useState } from "react";

export const useActiveSection = (anchors: string[]) => {
  const [activeSection, setActiveSection] = useState<string>("");

  useEffect(() => {
    const observerOptions = {
      rootMargin: "-60% 0px -65% 0px",
      threshold: 0,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const id = entry.target.id;
          if (anchors.includes(id)) {
            setActiveSection(id);
          }
        }
      });
    }, observerOptions);

    // Observar todas as seções
    anchors.forEach((anchor) => {
      const element = document.getElementById(anchor);
      if (element) {
        observer.observe(element);
      }
    });

    return () => {
      observer.disconnect();
    };
  }, [anchors]);

  return activeSection;
};
